import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import CoachingPageHeader from '../_partials/CoachingPageHeader';
import GiveFeedbackOrKudosModal from 'Shared/components/GiveFeedbackOrKudosModal/GiveFeedbackOrKudosModal';
import UserProfileKudos from 'Dashboard/components/UserProfilePage/ProfileContents/UserProfileKudos';

const CoachingKudosPage = () => {
  const { user } = useCurrentUser();

  const [isGiveFeedbackOrKudosModalOpen, toggleIsGiveFeedbackOrKudosModalOpen] = useToggle(false);

  const handleGiveKudosClick = () => {
    toggleIsGiveFeedbackOrKudosModalOpen();
  };

  return (
    <>
      <div>
        <CoachingPageHeader
          title="Kudos"
          description="Recognize a job well done with a quick kudos."
          size="lg"
          buttons={
            <WpButtonGroup>
              <WpButton onClick={handleGiveKudosClick}>
                <WpIcon name="gem" />
                Give Kudos
              </WpButton>
            </WpButtonGroup>
          }
        />
        <UserProfileKudos user={user} showTitle={false} />
      </div>
      <GiveFeedbackOrKudosModal
        flow="kudos"
        isOpen={isGiveFeedbackOrKudosModalOpen}
        toggleIsOpen={toggleIsGiveFeedbackOrKudosModalOpen}
      />
    </>
  );
};

export default CoachingKudosPage;
